import { render, staticRenderFns } from "./WaveOpticsViz.vue?vue&type=template&id=720a5015&scoped=true"
import script from "./WaveOpticsViz.vue?vue&type=script&lang=js"
export * from "./WaveOpticsViz.vue?vue&type=script&lang=js"
import style0 from "./WaveOpticsViz.vue?vue&type=style&index=0&id=720a5015&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a5015",
  null
  
)

export default component.exports